import shopInfos from 'template/infos'

export type WebTracker = 'matomo' | 'google_analytics' | 'none'

type TrackerEnvValue = string | undefined

const templateTrackerInfos = shopInfos as typeof shopInfos & {
  siteId?: number | string
  containerId?: string
}

const cleanEnv = (value: string | undefined) => {
  return typeof value === 'string' && value.trim() !== ''
    ? value.trim()
    : undefined
}

const normalizeTracker = (value: TrackerEnvValue): WebTracker | undefined => {
  const tracker = value?.trim().toLowerCase()
  if (!tracker) return undefined

  if (tracker === 'matomo' || tracker === 'matamo') return 'matomo'
  if (
    tracker === 'google_analytics'
    || tracker === 'google-analytics'
    || tracker === 'googleanalytics'
    || tracker === 'ga'
    || tracker === 'gtag'
  ) return 'google_analytics'
  if (tracker === 'none' || tracker === 'off' || tracker === 'false' || tracker === 'disabled') return 'none'

  return undefined
}

const matomoSiteId = cleanEnv(process.env.NEXT_PUBLIC_MATOMO_SITE_ID)
  || (templateTrackerInfos.siteId ? String(templateTrackerInfos.siteId) : undefined)

const matomoContainerId = cleanEnv(process.env.NEXT_PUBLIC_MATOMO_CONTAINER_ID)
  || templateTrackerInfos.containerId

const googleAnalyticsId = cleanEnv(process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID)
  || cleanEnv(process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID)

const tracker = normalizeTracker(
  cleanEnv(process.env.NEXT_PUBLIC_WEB_TRACKER)
    || cleanEnv(process.env.NEXT_PUBLIC_ANALYTICS_PROVIDER)
)
  || (googleAnalyticsId ? 'google_analytics' : undefined)
  || (matomoSiteId && matomoContainerId ? 'matomo' : 'none')

export const analyticsConfig = {
  tracker,
  matomo: {
    siteId: matomoSiteId,
    containerId: matomoContainerId,
    baseUrl: (cleanEnv(process.env.NEXT_PUBLIC_MATOMO_URL) || 'https://trackmatomo.angelinaminardi.de').replace(/\/$/, ''),
  },
  googleAnalytics: {
    measurementId: googleAnalyticsId,
  },
} as const

export const analyticsTrackerLabel = (() => {
  if (analyticsConfig.tracker === 'google_analytics') return 'Google Analytics'
  if (analyticsConfig.tracker === 'matomo') return 'Matomo'
  return 'Webanalyse'
})()

export const hasOptionalAnalytics = analyticsConfig.tracker !== 'none'

export const analyticsConsentDescription = (() => {
  if (analyticsConfig.tracker === 'google_analytics') {
    return 'Google Analytics zur Reichweiten- und Performance-Messung inklusive Core Web Vitals sowie zur Verbesserung unseres Shops'
  }
  if (analyticsConfig.tracker === 'matomo') {
    return 'Matomo zur Reichweiten- und Performance-Messung inklusive Core Web Vitals sowie zur Verbesserung unseres Shops'
  }
  return 'optionale Analyse- oder Performance-Cookies'
})()
